import FileViewer from './components'

export default FileViewer
